if (!customElements.get('product-form')) {
  let pfToast;

  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        this.submitButtonText =
          this.submitButton
            ? this.submitButton.querySelector('span')
            : null;

        if (
          document.querySelector('cart-drawer') &&
          this.submitButton
        ) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }

      /*
      ======================================================
      ADD TO CART
      ======================================================
      */

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton) return;

        if (
          this.submitButton.getAttribute('aria-disabled') ===
          'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add(
          'loading'
        );

        const spinner =
          this.querySelector(
            '.loading__spinner'
          );

        if (spinner) {
          spinner.classList.remove(
            'hidden'
          );
        }

        const config =
          fetchConfig('javascript');

        config.headers[
          'X-Requested-With'
        ] = 'XMLHttpRequest';

        delete config.headers[
          'Content-Type'
        ];

        const formData =
          new FormData(this.form);

        /*
        ------------------------------------------------------
        CART SECTIONS
        ------------------------------------------------------
        */

        if (this.cart) {
          if (
            typeof this.cart.getSectionsToRender ===
            'function'
          ) {
            formData.append(
              'sections',
              this.cart
                .getSectionsToRender()
                .map((section) => section.id)
            );
          }

          formData.append(
            'sections_url',
            window.location.pathname
          );

          if (
            typeof this.cart.setActiveElement ===
            'function'
          ) {
            this.cart.setActiveElement(
              document.activeElement
            );
          }
        }

        config.body = formData;

        fetch(
          `${routes.cart_add_url}`,
          config
        )
          .then((response) =>
            response.json()
          )

          .then((response) => {
            /*
            ==================================================
            ERROR RESPONSE
            ==================================================
            */

            if (response.status) {
              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source: 'product-form',

                  productVariantId:
                    formData.get('id'),

                  errors:
                    response.errors ||
                    response.description,

                  message:
                    response.message,
                }
              );

              this.handleErrorMessage(
                response.description
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) {
                return;
              }

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              if (this.submitButtonText) {
                this.submitButtonText.classList.add(
                  'hidden'
                );
              }

              soldOutMessage.classList.remove(
                'hidden'
              );

              this.error = true;

              return;
            }

            /*
            ==================================================
            NO CART DRAWER
            ==================================================
            */

            if (!this.cart) {
              window.location =
                window.routes.cart_url;

              return;
            }

            /*
            ==================================================
            CART UPDATE EVENT
            ==================================================
            */

            if (
              typeof CartPerformance !==
                'undefined' &&
              typeof CartPerformance.createStartingMarker ===
                'function'
            ) {
              const startMarker =
                CartPerformance.createStartingMarker(
                  'add:wait-for-subscribers'
                );

              if (!this.error) {
                publish(
                  PUB_SUB_EVENTS.cartUpdate,
                  {
                    source: 'product-form',

                    productVariantId:
                      formData.get('id'),

                    cartData: response,
                  }
                ).then(() => {
                  if (
                    typeof CartPerformance.measureFromMarker ===
                    'function'
                  ) {
                    CartPerformance.measureFromMarker(
                      'add:wait-for-subscribers',
                      startMarker
                    );
                  }
                });
              }
            } else {
              if (!this.error) {
                publish(
                  PUB_SUB_EVENTS.cartUpdate,
                  {
                    source: 'product-form',

                    productVariantId:
                      formData.get('id'),

                    cartData: response,
                  }
                );
              }
            }

            this.error = false;

            /*
            ==================================================
            SUCCESS POPUP

            IMPORTANT:
            This only shows the floating popup.
            There is NO 5-second button/card timer.
            ==================================================
            */

            this.showAddedFeedback();

            /*
            ==================================================
            QUICK ADD MODAL
            ==================================================
            */

            const quickAddModal =
              this.closest(
                'quick-add-modal'
              );

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (
                      typeof CartPerformance !==
                        'undefined' &&
                      typeof CartPerformance.measure ===
                        'function'
                    ) {
                      CartPerformance.measure(
                        'add:paint-updated-sections',
                        () => {
                          this.updateAndOpenCart(
                            response
                          );
                        }
                      );
                    } else {
                      this.updateAndOpenCart(
                        response
                      );
                    }
                  }, 50);
                },
                {
                  once: true,
                }
              );

              quickAddModal.hide(true);
            } else {
              /*
              =================================================
              NORMAL PRODUCT / CARD
              =================================================
              */

              if (
                typeof CartPerformance !==
                  'undefined' &&
                typeof CartPerformance.measure ===
                  'function'
              ) {
                CartPerformance.measure(
                  'add:paint-updated-sections',
                  () => {
                    this.updateAndOpenCart(
                      response
                    );
                  }
                );
              } else {
                this.updateAndOpenCart(
                  response
                );
              }
            }
          })

          .catch((error) => {
            console.error(
              'Add to cart error:',
              error
            );
          })

          .finally(() => {
            /*
            ==================================================
            RESET LOADING STATE
            ==================================================
            */

            this.submitButton.classList.remove(
              'loading'
            );

            if (
              this.cart &&
              this.cart.classList.contains(
                'is-empty'
              )
            ) {
              this.cart.classList.remove(
                'is-empty'
              );
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            const spinner =
              this.querySelector(
                '.loading__spinner'
              );

            if (spinner) {
              spinner.classList.add(
                'hidden'
              );
            }

            if (
              typeof CartPerformance !==
                'undefined' &&
              typeof CartPerformance.measureFromEvent ===
                'function'
            ) {
              CartPerformance.measureFromEvent(
                'add:user-action',
                evt
              );
            }
          });
      }

      /*
      ======================================================
      UPDATE CART + OPEN DRAWER
      ======================================================
      */

      updateAndOpenCart(response) {
        const cart =
          document.querySelector(
            'cart-drawer'
          ) ||
          this.cart;

        if (!cart) return;

        /*
        ------------------------------------------------------
        UPDATE DRAWER CONTENT
        ------------------------------------------------------
        */

        if (
          typeof cart.renderContents ===
          'function'
        ) {
          cart.renderContents(
            response
          );
        } else {
          this.updateCartSilently(
            response
          );
        }

        /*
        ------------------------------------------------------
        REMOVE EMPTY STATES
        ------------------------------------------------------
        */

        if (
          cart.classList.contains(
            'is-empty'
          )
        ) {
          cart.classList.remove(
            'is-empty'
          );
        }

        const inner =
          cart.querySelector(
            '.drawer__inner'
          );

        if (
          inner &&
          inner.classList.contains(
            'is-empty'
          )
        ) {
          inner.classList.remove(
            'is-empty'
          );
        }

        /*
        ------------------------------------------------------
        OPEN DRAWER

        NO AUTO-CLOSE TIMER HERE.
        ------------------------------------------------------
        */

        window.setTimeout(() => {
          this.openCartDrawer();
        }, 100);
      }

      /*
      ======================================================
      OPEN CART DRAWER
      ======================================================
      */

      openCartDrawer() {
        const cartDrawer =
          document.querySelector(
            'cart-drawer'
          );

        if (!cartDrawer) {
          window.location.href =
            window.routes.cart_url;

          return;
        }

        /*
        ------------------------------------------------------
        USE THEME'S BUILT-IN OPEN()
        ------------------------------------------------------
        */

        if (
          typeof cartDrawer.open ===
          'function'
        ) {
          cartDrawer.open();

          return;
        }

        /*
        ------------------------------------------------------
        FALLBACK
        ------------------------------------------------------
        */

        cartDrawer.classList.add(
          'animate',
          'active'
        );

        document.body.classList.add(
          'overflow-hidden'
        );
      }

      /*
      ======================================================
      CURRENT PRODUCT IMAGE
      ======================================================
      */

    getCurrentProductImage() {
  let image = null;

  // Mobile
  if (window.innerWidth < 750) {
    image =
      document.querySelector(
        '.product-media-gallery__mobile .swiper-slide-active img'
      ) ||
      document.querySelector(
        '.product-media-gallery__mobile .product-media-gallery__mobile-slide img'
      );
  }

  // Desktop
  if (!image) {
    image =
      document.querySelector(
        '.product-media-gallery__desktop .owl-item.active img'
      ) ||
      document.querySelector(
        '.product-media-gallery__desktop .product-media-gallery__desktop-item img'
      );
  }

  // Fallback
  if (!image) {
    image = document.querySelector(
      '.product-media-gallery__desktop img, .product-media-gallery__mobile img'
    );
  }

  if (!image) return '';

  const src =
    image.currentSrc ||
    image.getAttribute('src') ||
    image.getAttribute('data-src') ||
    '';

  if (!src) return '';

  if (src.startsWith('//')) {
    return `${window.location.protocol}${src}`;
  }

  return src;
}

      /*
      ======================================================
      CREATE SUCCESS POPUP
      ======================================================
      */

      ensureToast() {
        if (pfToast) {
          return pfToast;
        }

        /*
        ------------------------------------------------------
        POPUP CSS
        ------------------------------------------------------
        */

        if (
          !document.getElementById(
            'pf-toast-styles'
          )
        ) {
          const style =
            document.createElement(
              'style'
            );

          style.id =
            'pf-toast-styles';

          style.textContent = `
            .pf-toast {
              position: fixed;
              left: 24px;
              bottom: 24px;

              width: 360px;
              max-width: calc(100vw - 30px);
              height: 130px;

              display: grid;
              grid-template-columns: 110px 1fr;

              background: #d4c2b5;

              z-index: 9999999;

              opacity: 0;
              visibility: hidden;
              pointer-events: none;

              transform: translateY(15px);

              transition:
                opacity .3s ease,
                visibility .3s ease,
                transform .3s ease;

              box-shadow:
                0 2px 10px rgba(0,0,0,.08);

              overflow: hidden;

              font-family: inherit;
            }

            .pf-toast.is-visible {
              opacity: 1;
              visibility: visible;
              pointer-events: auto;

              transform: translateY(0);
            }

            .pf-toast__image-wrap {
              width: 110px;
              height: 130px;

              display: flex;
              align-items: center;
              justify-content: center;

              background: #fff;

              overflow: hidden;
            }

            .pf-toast__image {
              width: 100%;
              height: 100%;

              display: block;

              object-fit: contain;
            }

            .pf-toast__content {
              min-width: 0;

              display: flex;
              flex-direction: column;
              justify-content: center;

              padding:
                24px 44px 22px 16px;
            }

            .pf-toast__title {
              margin:
                0 0 12px 0;

              padding: 0;

              font-family: inherit;

              font-size: 13px;
              line-height: 1.2;

              font-weight: 400;

              letter-spacing: .04em;

              text-transform: uppercase;

              color: #1d1d1d;
            }

            .pf-toast__cart-link {
              display: inline-block;

              width: fit-content;

              margin: 0;

              padding:
                0 0 3px 0;

              border: 0;

              border-bottom:
                1px solid #1d1d1d;

              background: transparent;

              color: #1d1d1d;

              font-family: inherit;

              font-size: 12px;
              line-height: 1.2;

              font-weight: 400;

              letter-spacing: .02em;

              text-transform: uppercase;

              text-decoration: none;

              cursor: pointer;
            }

            .pf-toast__check {
              position: absolute;

              top: 14px;
              right: 14px;

              width: 21px;
              height: 21px;

              display: flex;
              align-items: center;
              justify-content: center;

              border-radius: 50%;

              background:
                rgba(255,255,255,.60);

              color: #777;

              font-size: 12px;
              line-height: 1;

              font-weight: 400;
            }

            .pf-toast__progress {
              position: absolute;

              left: 0;
              bottom: 0;

              width: 100%;
              height: 2px;

              overflow: hidden;

              pointer-events: none;
            }

            .pf-toast__bar {
              display: block;

              width: 100%;
              height: 100%;

              background:
                rgba(0,0,0,.35);

              transform: scaleX(0);

              transform-origin:
                left center;

              will-change: transform;
            }

            @media screen and (max-width: 749px) {
              .pf-toast {
                left: 15px;
                right: 15px;
                bottom: 15px;

                width: auto;
                max-width: none;

                height: 120px;

                grid-template-columns:
                  105px 1fr;
              }

              .pf-toast__image-wrap {
                width: 105px;
                height: 120px;
              }

              .pf-toast__content {
                padding:
                  20px 40px 18px 14px;
              }

              .pf-toast__title {
                font-size: 12px;

                margin-bottom: 10px;
              }

              .pf-toast__cart-link {
                font-size: 11px;
              }

              .pf-toast__check {
                top: 12px;
                right: 12px;
              }
            }
          `;

          document.head.appendChild(
            style
          );
        }

        /*
        ------------------------------------------------------
        POPUP HTML
        ------------------------------------------------------
        */

        const toast =
          document.createElement(
            'div'
          );

        toast.className =
          'pf-toast';

        toast.setAttribute(
          'role',
          'status'
        );

        toast.setAttribute(
          'aria-live',
          'polite'
        );

        toast.innerHTML = `
          <div class="pf-toast__image-wrap">
            <img
              class="pf-toast__image"
              src=""
              alt=""
            >
          </div>

          <div class="pf-toast__content">
            <p class="pf-toast__title">
              PRODUCT ADDED
            </p>

            <button
              type="button"
              class="pf-toast__cart-link"
            >
              GO TO CART
            </button>
          </div>

          <span
            class="pf-toast__check"
            aria-hidden="true"
          >
            ✓
          </span>

          <span
            class="pf-toast__progress"
            aria-hidden="true"
          >
            <span
              class="pf-toast__bar"
            ></span>
          </span>
        `;

        document.body.appendChild(
          toast
        );

        /*
        ------------------------------------------------------
        GO TO CART
        ------------------------------------------------------
        */

        const cartButton =
          toast.querySelector(
            '.pf-toast__cart-link'
          );

        if (cartButton) {
          cartButton.addEventListener(
            'click',
            (event) => {
              event.preventDefault();
              event.stopPropagation();

              this.openCartDrawer();
            }
          );
        }

        pfToast = toast;

        return toast;
      }

      /*
      ======================================================
      SHOW SUCCESS POPUP

      THIS IS THE ONLY 5 SECOND TIMER
      ======================================================
      */

      showToast(duration = 5000) {
        const toast =
          this.ensureToast();

        const image =
          toast.querySelector(
            '.pf-toast__image'
          );

        const imageWrap =
          toast.querySelector(
            '.pf-toast__image-wrap'
          );

        const productImage =
          this.getCurrentProductImage();

        /*
        ------------------------------------------------------
        PRODUCT IMAGE
        ------------------------------------------------------
        */

        if (
          image &&
          productImage
        ) {
          image.src =
            productImage;

          image.removeAttribute(
            'hidden'
          );

          if (imageWrap) {
            imageWrap.removeAttribute(
              'hidden'
            );
          }
        } else {
          if (imageWrap) {
            imageWrap.setAttribute(
              'hidden',
              ''
            );
          }
        }

        /*
        ------------------------------------------------------
        CLEAR PREVIOUS POPUP TIMER
        ------------------------------------------------------
        */

        if (
          toast._hideTimer
        ) {
          window.clearTimeout(
            toast._hideTimer
          );

          toast._hideTimer =
            null;
        }

        /*
        ------------------------------------------------------
        SHOW POPUP
        ------------------------------------------------------
        */

        toast.classList.add(
          'is-visible'
        );

        /*
        ------------------------------------------------------
        PROGRESS BAR
        ------------------------------------------------------
        */

        const bar =
          toast.querySelector(
            '.pf-toast__bar'
          );

        if (bar) {
          bar.style.transition =
            'none';

          bar.style.transform =
            'scaleX(0)';

          void bar.offsetWidth;

          bar.style.transition =
            `transform ${duration}ms linear`;

          bar.style.transform =
            'scaleX(1)';
        }

        /*
        ------------------------------------------------------
        AFTER 5 SEC:

        ONLY HIDE .pf-toast

        CART DRAWER IS NOT SELECTED
        CART DRAWER IS NOT CLOSED
        BODY CLASS IS NOT REMOVED
        ------------------------------------------------------
        */

        toast._hideTimer =
          window.setTimeout(() => {
            toast.classList.remove(
              'is-visible'
            );

            if (bar) {
              bar.style.transition =
                'none';

              bar.style.transform =
                'scaleX(0)';
            }

            toast._hideTimer =
              null;

          }, duration);
      }

      /*
      ======================================================
      SUCCESS FEEDBACK

      NO BUTTON TIMER
      NO CARD TIMER
      NO DRAWER TIMER
      ======================================================
      */

      showAddedFeedback() {
        this.showToast(5000);
      }

      /*
      ======================================================
      FALLBACK CART UPDATE
      ======================================================
      */

      updateCartSilently(response) {
        const cart =
          this.cart;

        if (
          !cart ||
          !response ||
          !response.sections
        ) {
          return;
        }

        if (
          typeof cart.getSectionsToRender !==
            'function' ||
          typeof cart.getSectionInnerHTML !==
            'function'
        ) {
          return;
        }

        cart
          .getSectionsToRender()
          .forEach((section) => {
            const element =
              section.selector
                ? document.querySelector(
                    section.selector
                  )
                : document.getElementById(
                    section.id
                  );

            const html =
              response.sections[
                section.id
              ];

            if (
              !element ||
              !html
            ) {
              return;
            }

            element.innerHTML =
              cart.getSectionInnerHTML(
                html,
                section.selector
              );
          });

        if (
          cart.classList.contains(
            'is-empty'
          )
        ) {
          cart.classList.remove(
            'is-empty'
          );
        }

        const inner =
          cart.querySelector(
            '.drawer__inner'
          );

        if (
          inner &&
          inner.classList.contains(
            'is-empty'
          )
        ) {
          inner.classList.remove(
            'is-empty'
          );
        }
      }

      /*
      ======================================================
      ERROR MESSAGE
      ======================================================
      */

      handleErrorMessage(
        errorMessage = false
      ) {
        if (
          this.hideErrors
        ) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (
          !this.errorMessageWrapper
        ) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      /*
      ======================================================
      TOGGLE SUBMIT BUTTON
      ======================================================
      */

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (
          !this.submitButton
        ) {
          return;
        }

        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (
            text &&
            this.submitButtonText
          ) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          if (
            this.submitButtonText &&
            window.variantStrings
          ) {
            this.submitButtonText.textContent =
              window.variantStrings.addToCart;
          }
        }
      }

      /*
      ======================================================
      VARIANT INPUT
      ======================================================
      */

      get variantIdInput() {
        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}